/**
 * English: LLM token usage dashboard — in-memory stats and PostgreSQL history charts.
 * Thai: แดชบอร์ดการใช้ token ของ LLM — สรุปใน memory และกราฟประวัติจาก PostgreSQL
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SessionTab from '../components/usage/SessionTab';
import HistoryTab from '../components/usage/HistoryTab';
import LogTab from '../components/usage/LogTab';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';

type Tab = 'session' | 'history' | 'log';

export default function UsagePage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<Tab>('session');

  const tabClass = (active: boolean) =>
    `px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
      active
        ? 'border-app-accent text-app-accent'
        : 'border-transparent text-app-text-dim hover:text-app-text'
    }`;

  return (
    <PageShell>
      <PageHeader title={t('usage.title')} description={t('usage.description')} />

      <div className="flex flex-wrap gap-1 border-b border-app-border">
        <button type="button" onClick={() => setTab('session')} className={tabClass(tab === 'session')}>
          {t('usage.tabSession')}
        </button>
        <button type="button" onClick={() => setTab('history')} className={tabClass(tab === 'history')}>
          {t('usage.tabHistory')}
        </button>
        <button type="button" onClick={() => setTab('log')} className={tabClass(tab === 'log')}>
          {t('usage.tabLog')}
        </button>
      </div>

      {tab === 'session' && <SessionTab />}
      {tab === 'history' && <HistoryTab />}
      {tab === 'log' && <LogTab />}

      <p className="text-[11px] text-app-text-dim leading-relaxed">{t('usage.footnote')}</p>
    </PageShell>
  );
}
